var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-simple',_vm._b({attrs:{"height":"550px"}},'widget-simple',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }